module.exports = __webpack_public_path__ + "static/media/t3-drop.933ee0c2.svg";